// extracted by mini-css-extract-plugin
export var container = "quote-module--container--b9a5c";
export var description = "quote-module--description--45259";
export var descriptionContainer = "quote-module--descriptionContainer--040bd";
export var image = "quote-module--image--6a307";
export var imageContainer = "quote-module--imageContainer--5f81e";
export var infoContainer = "quote-module--infoContainer--7d394";
export var line = "quote-module--line--504bd";
export var quote = "quote-module--quote--3ebb6";
export var quoteContainer = "quote-module--quoteContainer--ad7ee";
export var title = "quote-module--title--5b342";